export const environment = {
  production: false,
  title: 'Development Environment',
  apiURL: 'https://demoapi.omniassist.co.in',
  googleClientId: '610405099105-ev21n1v5nik6qmvch5uf90kianmvlu59.apps.googleusercontent.com',
  omniWebsite: 'http://localhost:62787',
  omniAdmin: 'http://localhost:4200'
};